import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SurveyForm from "./components/SurveyForm";
import SurveyResults from "./pages/SurveyResults";
import ReferralManager from "./pages/ReferralManager";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SurveyForm />} />
        <Route path="/results" element={<SurveyResults />} />
        <Route path="/referrals" element={<ReferralManager />} />{" "}
      </Routes>
    </Router>
  );
}
